import { IAction } from '@Root/types'

export const StatisticsActionTypes = {
  GET_CREDIT_USAGE:'@@statistics/GET_CREDIT_USAGE',
  GET_CREDIT_USAGE_SUCCESS:'@@statistics/GET_CREDIT_USAGE_SUCCESS',
  GET_CREDIT_USAGE_FAILURE:'@@statistics/GET_CREDIT_USAGE_FAILURE',
  GET_PROJECT_CREATION:'@@statistics/GET_PROJECT_CREATION',
  GET_PROJECT_CREATION_SUCCESS:'@@statistics/GET_PROJECT_CREATION_SUCCESS',
  GET_PROJECT_CREATION_FAILURE:'@@statistics/GET_PROJECT_CREATION_FAILURE',
}

export interface IStatisticsState {
  readonly loading: boolean
  readonly creditUsageData: { analysis: ICreditUsageEntry[], nonAnalysis: ICreditUsageEntry[] }
  readonly projectCreationData: IProjectCreationEntry[]
}

export interface IGetCreditUsagePayload {
  readonly period: string
  readonly accountId: number
  readonly userIds?: number[]
  readonly workspaceIds?: number[]
  readonly startDate?: string
  readonly endDate?: string
}

export type IGetProjectCreationPayload = IGetCreditUsagePayload

export interface IStatisticsEntry {
  readonly date: string
}

export interface ICreditUsageEntry extends IStatisticsEntry {
  readonly credits: number
}

export interface IProjectCreationEntry extends IStatisticsEntry {
  readonly projectsCount: number
}

export interface IGetCreditUsageSuccessResponseBody {
  readonly statistics: { analysis: ICreditUsageEntry[], nonAnalysis: ICreditUsageEntry[] }
}

export interface IGetProjectCreationSuccessResponseBody {
  readonly statistics: IProjectCreationEntry[]
}

export type TStatisticsActionTypes =
  IAction<IGetCreditUsageSuccessResponseBody> |
  IAction<IGetProjectCreationSuccessResponseBody>
